import { CUSTOM_ELEMENTS_SCHEMA, ApplicationConfig, importProvidersFrom } from '@angular/core';
import {
  PreloadAllModules,
  provideRouter,
  withPreloading,
  withComponentInputBinding,
  withEnabledBlockingInitialNavigation
} from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClientJsonpModule, provideHttpClient, withInterceptors, withJsonpSupport } from '@angular/common/http';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { routes } from './app.routes';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NxExpertModule } from '@aposin/ng-aquila/config';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { MultiasistenciaLibraryModule } from '@multiasistencia/multiasistencia';
import { NxModalModule } from '@aposin/ng-aquila/modal';
import { environment } from '../environments/environment';
import { authInterceptor } from './core/services/nx-auth-interceptor/auth-interceptor.service';

export function createTranslateLoader(http: HttpClient) {
  return new TranslateHttpLoader(http);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      routes,
      withPreloading(PreloadAllModules),
      withEnabledBlockingInitialNavigation(),
      withComponentInputBinding()
    ),
    provideHttpClient(withJsonpSupport(), withInterceptors([authInterceptor])),
    importProvidersFrom(
      HttpClientModule,
      BrowserModule,
      BrowserAnimationsModule,
      NxExpertModule,
      NxModalModule,
      HttpClientJsonpModule,
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: createTranslateLoader,
          deps: [HttpClient]
        },
        defaultLanguage: 'fr'
      }),
      MultiasistenciaLibraryModule.forRoot({
        apiUrl: environment.apiUrl,
        apiGoogle: environment.apiGoogle,
        s3Url: environment.s3Url,
        isSelfcare: true,
        apiBillma: environment.apiBillma,
        adobeUrl: environment.adobeUrl
      })
    ),
    provideAnimations()
  ]
};
